<template>
  <div>
    <div class="row p-3 pt-0" v-show="loading_bar">
      <v-progress-linear indeterminate color="cyan"></v-progress-linear>
    </div>
    <div class="row">
      <div class="card col-md-6">
        <div class="card-content form-group">
          <h4 class="card-title">Reporte de Declaraciones</h4>

          <div class="row">
            <div class="col-md-6 form-group">
              <label>Estatus</label><br>
              <el-select clearable class="select-default" filterable name="estatus" placeholder="Estatus" v-model="model.estatus">
                <el-option v-for="option in estatus" class="select-default" :value="option.id" :label="option.estatus" :key="option.estatus">
                </el-option>
              </el-select>
            </div>
            <div class="col-md-6 form-group">
              <label>Declaración </label><br>
              <el-select clearable class="select-default" filterable name="declaracion" placeholder="Declaracion" v-model="model.tipo_declaracion">
                <el-option v-for="option in tiposDeclaracion" class="select-default" :value="option.id" :label="option.tipo_declaracion" :key="option.tipo_declaracion">
                </el-option>
              </el-select>
            </div>
          </div>
          <div v-if="getKey('permisos').includes(14)">
            <label>Dependencia </label><br>
            <el-select clearable class="select-default" filterable name="dependencia" placeholder="Dependencia" v-model="model.dependencia_id">
              <el-option v-for="option in dependencias" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>

          <br>
          <label>Año</label><br>
          <el-select clearable class="select-default" filterable name="periodo" placeholder="Periodo" v-model="model.periodo">
            <el-option v-for="option in periodos" class="select-default" :value="option.year" :label="option.year" :key="option.year">
            </el-option>
          </el-select>

          <br>
          <label>Tipo de Reporte</label><br>
          <el-select clearable class="select-default" filterable name="reporte" placeholder="Tipo de reporte" v-model="model.tipo_reporte">
            <el-option v-for="option in tiposReporte" class="select-default" :value="option.id" :label="option.tipo_reporte" :key="option.tipo_reporte">
            </el-option>
          </el-select>

        </div>

        <div class="col-md-8 col-md-offset-3">
          <button @click="getDeclarantes" class="btn btn-success btn-wd pull-right" :disabled="loading_bar">
            {{ loading_bar? 'Buscando datos':'Buscar'}}
          </button>
        </div>
        <br>
      </div>
      <div class="col-md-6">
        <br>
        <circle-chart-card :percentage="avance" :title="dependenciaT" :avance="avanced" :total="totald" :description="model.periodo">
        </circle-chart-card>
      </div>
    </div>
    <div class="card">
      <div class="card-content" v-if="model.tipo_reporte != 2 ">
        <h4 class="card-title text-center" v-if="model.tipo_declaracion<4">Declaraciones Realizadas</h4>
        <h4 v-if="model.tipo_declaracion==4" class="card-title text-center">Con Conflicto</h4>
        <h4 v-if="model.tipo_declaracion==5" class="card-title text-center">Con Declaración fiscal</h4>

        <div class="row">
          <div class="col-sm-6">
            <export-excel class="btn btn-wd btn-success" :data="list_declarantes" :meta="meta" :fields="cumplidos_campos" worksheet="Cumplidos" :name="nombreC">
              <span class="btn-label">
                <i class="fa fa-file-excel"></i>
              </span>
              Descargar Reporte
            </export-excel>

          </div>
          <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
            <b-form-group>
              <b-input-group>
                <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </div>

        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-data-table :headers="headers" :items="list_declarantes" :items-per-page="5" class="" :search="filter" :fixed-header="true">
            </v-data-table>
          </div>
        </div>


        <br>
      </div>

    </div>
    <div class="card">

      <div class="card-content" v-if="model.tipo_reporte != 1">
        <h4 class="card-title text-center">Declaraciones Faltantes</h4>
        <h4 v-if="model.tipo_declaracion==4" class="card-title text-center">Sin Conflicto</h4>
        <div class="row">
          <div class="col-sm-6">

            <export-excel class="btn btn-wd btn-success" :data="list_declarantes2" :meta="meta" :fields="faltantes_campos" worksheet="Faltantes" :name="nombreF">
              <span class="btn-label">
                <i class="fa fa-file-excel"></i>
              </span>
              Descargar Reporte
            </export-excel>
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
            <b-form-group>
              <b-input-group>
                <b-form-input type="search" v-model="filter2" placeholder="Buscar"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
        </div>

        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-data-table :headers="headers2" :items="list_declarantes2" :items-per-page="5" class="" :search="filter2" :fixed-header="true">
            </v-data-table>
          </div>
        </div>
        <br>
      </div>
    </div>
  </div>
</template>
<script>
  import {
Option, Select, Table,
TableColumn
} from 'element-ui'
import moment from 'moment'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
import PPagination from 'src/components/UIComponents/Pagination.vue'
import Vue from 'vue'
import excel from 'vue-excel-export'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(excel)

  export default {
    components: {
      StatsCard,
      ChartCard,
      CircleChartCard,
      PPagination
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        model: {
          tipo_declaracion: '',
          dependencia_id: '',
          periodo: ''
        },
        loading_bar: false,
        dependencias: {},
        rol: '',
        periodos: [],
        dependenciaT: '',
        mostrar: false,
        perPage: 5,
        rows: null,
        currentPage: 1,
        filter: null,
        perPage2: 5,
        rows2: null,
        currentPage2: 1,
        filter2: null,
        tiposDeclaracion: [{
          'id': 1,
          'tipo_declaracion': 'Inicial'
        }, {
          'id': 2,
          'tipo_declaracion': 'Anual'
        }, {
          'id': 3,
          'tipo_declaracion': 'Final'
        }],
        estatus: [{
          'id': 1,
          'estatus': 'Activos'
        }, {
          'id': 2,
          'estatus': 'Bajas'
        }, {
          'id': 3,
          'estatus': 'Todos'
        }],
        tiposReporte: [{
          'id': 1,
          'tipo_reporte': 'Declaraciones Realizadas'
        }, {
          'id': 2,
          'tipo_reporte': 'Declaraciones Faltantes'
        }, {
          'id': 3,
          'tipo_reporte': 'Todos'
        }],
        list_declarantes: [],
        list_declarantes2: [],
        avance: 0,
        avanced: '',
        totald: '',
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        pagination2: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        searchQuery2: '',
        cumplidos_campos: {
          'RFC': 'rfc',
          'Nombres': 'nombres',
          //'Dependencia': 'dependencia',
          'Àrea': 'area',
          'Cargo': 'cargo',
          'Fecha': 'fecha'
        },
        nombreC: '',
        nombreF: '',
        cumplidos_data: [],
        faltantes_campos: {
          'RFC': 'rfc',
          'Nombres': 'nombres',
          'Dependencia': 'dependencia',
          'Àrea': 'area',
          'Cargo': 'cargo',
          'Correo Personal': 'correo1',
          'Correo Laboral': 'correo2',
          'Teléfono Personal': 'tel1',
          'Teléfono Laboral': 'tel2',
          'Fecha Creación': 'fecha1',
          'Fecha Posesión': 'fecha2',
          'Tipo': 'tipo'

        },
        faltantes_data: [],
        meta: [
          [{
            'key': 'charset',
            'value': 'utf-8'
          }]
        ],
        fecha: '',
        propsToSearch: ['rfc', 'nombres', 'cargo'],
        propsToSearch2: ['rfc', 'nombres', 'cargo', 'correo1', 'correo2', 'tel1', 'tel2'],
        headers: [{
            text: 'RFC',
            align: 'center',
            sortable: false,
            value: 'rfc',
            class: '',
            width: 150
          }, {
            text: 'Nombres',
            value: 'nombres',
            align: 'center',
          }, {
            text: 'Dependencia',
            value: 'dependencia',
            align: 'center',
          },
          {
            text: 'Área',
            value: 'area',
            align: 'center',
          },
          {
            text: 'Cargo',
            value: 'cargo',
            align: 'center',
          },
          {
            text: 'Declaración Fiscal',
            value: 'fiscal',
            align: 'center',
          },
          {
            text: 'Declaración de Intereses',
            value: 'intereses',
            align: 'center',
          },
          {
            text: 'Fecha de presentación',
            value: 'fecha',
            align: 'center',
          },
        ],
        fields_list: [{
            key: "rfc",
            label: "RFC",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "nombres",
            label: "Nombres",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "dependencia",
            label: "Dependencia",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "area",
            label: "Àrea",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "cargo",
            label: "Cargo",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "fiscal",
            label: "Declaración Fiscal",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "intereses",
            label: "Declaración de Intereses",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "fecha",
            label: "Fecha",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
        ],
        headers2: [{
            text: 'RFC',
            align: 'center',
            sortable: false,
            value: 'rfc',
            class: '',
            width: 150
          }, {
            text: 'Nombres',
            value: 'nombres',
            align: 'center',
          }, {
            text: 'Dependencia',
            value: 'dependencia',
            align: 'center',
          }, {
            text: 'Àrea',
            value: 'area',
            align: 'center',
          },
          {
            text: 'Cargo',
            value: 'cargo',
            align: 'center',
          },
          {
            text: 'Correo Personal',
            value: 'correo1',
            align: 'center',
          },
          {
            text: 'Correo Laboral',
            value: 'correo2',
            align: 'center',
          },
          {
            text: 'Tel Personal',
            value: 'tel1',
            align: 'center',
          },
          {
            text: 'Tel Laboral',
            value: 'tel2',
            align: 'center',
          },
        ],
        fields_list2: [{
            key: "rfc",
            label: "RFC",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "nombres",
            label: "Nombres",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "dependencia",
            label: "Dependencia",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "area",
            label: "Área",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "cargo",
            label: "Cargo",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "correo1",
            label: "Correo Personal",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "correo2",
            label: "Correo Laboral",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "tel1",
            label: "Tel Personal",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          },
          {
            key: "tel2",
            label: "Tel Laboral",
            tdClass: 'cump text-left',
            thClass: 'cump text-center'
          }
        ]
      }
    },
    computed: {
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.list_usuarios.length);
        this.rows = this.list_declarantes.length;

        return this.list_declarantes.length;
      },
      to2() {
        let highBound = this.from2 + this.perPage2;
        if (this.total2 < highBound) {
          highBound = this.total2;
        }
        return highBound;
      },
      from2() {
        return this.perPage2 * (this.currentPage2 - 1);
      },
      total2() {
        //console.log(this.list_usuarios.length);
        this.rows2 = this.list_declarantes2.length;

        return this.list_declarantes2.length;
      }
    },
    created() {
      //
      // console.log('ok: ' + this.$rootUrl);
      this.checkPermissions();
      this.getDependencias();
      // this.getTipoDeclaracion();
      this.getPeriodos();
      this.rol = this.getKey('role');
      var myDate = new Date();
      var mes = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var dia = ('0' + myDate.getDate()).slice(-2);
      var anio = myDate.getFullYear();
      this.fecha = dia + '/' + mes + '/' + anio;

      // this.model.periodo = anio;

      this.nombreC = "Cumplidos" + this.fecha + ".xls";
      this.nombreF = "Faltantes" + this.fecha + ".xls";

      if (!this.getKey('permisos').includes(14)) //permiso de declaraciones global
        this.model.dependencia_id = this.getKey('ente_publico_id')

    },
    mounted() {
      // this.checkCatalogs();
    },
    watch: {
      '$route': 'checkPermissions',
      'model.dependencia_id': function (newValue, oldValue) {
        console.log(newValue);
        var dep = this.dependencias.find(dep => dep.id == this.model.dependencia_id);
        this.dependenciaT = dep.valor ? dep.valor : '';
      },
    },
    methods: {
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows = filteredItems.length
        this.currentPage = 1
      },
      onFiltered2(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows2 = filteredItems.length
        this.currentPage2 = 1
      },
      checkPermissions() {
        let permiso = [10, 14];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }
      },
      /*  group1k(s) {
         let s1 = s.toString()
         if (s1.length > 3) {
           if (s1.length == 6) {
             s1 = s1.split('').reverse().join('').replace(/\d{3}/g, '$&,').split('').reverse().join('')
             return s1.substring(1, s1.length);
           } else {
             return s1.split('').reverse().join('').replace(/\d{3}/g, '$&,').split('').reverse().join('');
           }

         } else
           return s1
       }, */
      getDependencias() {
        var v = this;
        this.$http.get("cat_ente_publico").then(
          response => {
            this.dependencias = response.data.entes_publicos;
            this.dependencias.push({
              'codigo': 'T',
              'id': 0,
              'valor': 'TODAS'
            });
          },
          error => {
            this.StepError(error);
          }
        );
      },
      dateFormat: function (date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },

      getPeriodos() {
        var v = this;
        this.$http.get("getPeriodos").then(
          response => {
            this.periodos = response.data.periodos;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      formatTipo(tipo) {
        if (tipo == 1)
          return 'Simplificada'
        else
          return 'Completa'
      },
      getDeclarantes() {
        let url
        if (this.model.estatus != '' && this.model.tipo_declaracion != '' && this.model.dependencia_id >= 0 && this.model.periodo != '' && this.model.tipo_reporte >= 0) {
          this.list_declarantes2 = [];
          this.list_declarantes = [];
          this.avance = 0;
          this.avanced = '0';
          this.totald = '0';

          this.loading_bar = true;

          this.$http.post('repdeclarantes', this.model).then(
            response => {
              this.avance = Number((response.data.avance.toString().substring(0, 5)));

              this.avanced = this.group1k(response.data.total);

              this.totald = this.group1k(response.data.porcentaje);

              this.mostrar = true;
              let v = this;
              v.list_declarantes = [];
              v.list_declarantes2 = [];
              let fiscal;
              let intereses;
              if (this.model.tipo_reporte == 1) {
                $.each(response.data.declarantes, function (key, value) {
                  fiscal = 'NO';
                  intereses = 'NO';
                  if (value.declaracion_fiscal) {
                    fiscal = 'SI';
                  }
                  if (value.intereses) {
                    intereses = 'SI';
                  }
                  v.list_declarantes.push({
                    'rfc': value.rfc,
                    'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                    'dependencia': value.dependencia,
                    'area': value.area_adscripcion,
                    'cargo': value.empleo_cargo_comision,
                    'fiscal': fiscal,
                    'intereses': intereses,
                    'fecha': v.dateFormat(value.fecha_dec)
                  });
                });
              } else if (this.model.tipo_reporte == 2) {
                $.each(response.data.faltantes, function (key, value) {
                  v.list_declarantes2.push({
                    'rfc': value.rfc,
                    'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                    'dependencia': value.dependencia,
                    'area': value.area_adscripcion,
                    'cargo': value.empleo_cargo_comision,
                    'correo1': value.correo_electronico_personal || '',
                    'correo2': value.correo_electronico_laboral || '',
                    'tel1': value.telefono_particular || '',
                    'tel2': value.telefono_laboral || '',
                    'tipo': v.formatTipo(value.simplificada),
                    'fecha1': value.created_at,
                    'fecha2': value.fecha_posesion
                  });
                });
              } else {
                $.each(response.data.declarantes, function (key, value) {
                  fiscal = 'NO';
                  intereses = 'NO';

                  if (value.declaracion_fiscal) {
                    fiscal = 'SI';
                  }

                  if (value.intereses) {
                    intereses = 'SI';
                  }
                  v.list_declarantes.push({
                    'rfc': value.rfc,
                    'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                    'dependencia': value.dependencia,
                    'area': value.area_adscripcion,
                    'cargo': value.empleo_cargo_comision,
                    'fiscal': fiscal,
                    'intereses': intereses,
                    'fecha': v.dateFormat(value.fecha_dec)
                  });
                });

                $.each(response.data.faltantes, function (key, value) {
                  v.list_declarantes2.push({
                    'rfc': value.rfc,
                    'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                    'dependencia': value.dependencia, // value.encargo.ente.valor,
                    'area': value.area_adscripcion, // value.encargo.area_adscripcion,
                    'cargo': value.empleo_cargo_comision, // value.encargo.empleo_cargo_comision,
                    'correo1': value.correo_electronico_personal || '',
                    'correo2': value.correo_electronico_laboral || '',
                    'tel1': value.telefono_particular || '',
                    'tel2': value.telefono_laboral || '',
                    'tipo': v.formatTipo(value.simplificada),
                    'fecha1': value.created_at,
                    'fecha2': value.fecha_posesion
                  });
                });
              }
              this.loading_bar = false;
            },
            error => {
              this.StepError(error);
              this.loading_bar = false;
            }
          );

        } else {
          this.StepW('Llena todos los campos')
          this.loading_bar = false;
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/Declaraciones.vue